import React from "react"
import BannerContainer from "@components/BannerContainer"
import WrapperInner from "@components/WrapperInner"
import TopTitle from "@components/TopTitle"
import AnchorButton from "@components/CTAAnchorButton"
import PricingImage from "./Pricing.png"
import PricingMobileImage from "./Pricing-Mobile.png"
import gridBreakpoints from "@styles/bs-modifiers/grid-breakpoints.js"
import styles from "./BannerPricing.module.scss"
import classnames from "classnames/bind"

const BannerPricing = props => {
  return (
    <BannerContainer
      renderLeftWrapperChildren={() => {
        return (
          <React.Fragment>
            <div
              className={
                styles.contentWrapper + " pr-lg-10 text-center text-lg-left"
              }
            >
              <h1
                className={classnames(
                  styles.title,
                  "proxima-nova--bold",
                  "fs-30pt",
                  "text-white",
                  "fs-lg-40pt"
                )}
              >
                <TopTitle content="REGAIN CONTROL OF YOUR IDENTITIES" /> 
                THE MOST COST EFFECTIVE IDENTITY SOLUTION ON THE MARKET
              </h1>
              <AnchorButton
                href="/demo"
                content="SEE A DEMO"
                className={styles.button}
              />
            </div>

            <div className={styles.emptyBlockLeft + " w-100 bg-white"}></div>
          </React.Fragment>
        )
      }}
      rightClassName="align-items-center align-items-lg-end"
      renderRightWrapperChildren={() => {
        return (
          <React.Fragment>
            <WrapperInner className={styles.wrapperInnerRight + " pl-lg-10"}>
              <picture>
                <source
                  media={`(min-width: ${gridBreakpoints.lg}px)`}
                  srcSet={PricingImage}
                  className={styles.pricingImage + " w-100 ml-auto"}
                />
                <source
                  media={`(min-width: ${gridBreakpoints.xs}px)`}
                  srcSet={PricingMobileImage}
                  className={styles.pricingImage + " w-100 ml-auto"}
                />
                <img
                  src={PricingImage}
                  alt="Pricing"
                  className={styles.pricingImage + " w-100 ml-auto"}
                />
              </picture>
            </WrapperInner>
            <div className={styles.emptyBlockRight + " w-100 bg-white"}></div>
          </React.Fragment>
        )
      }}
    />
  )
}

export default BannerPricing
